// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.0
// source: bosdyn/api/payload.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Box3WithFrame, SE3Pose, Vec3 } from "./geometry";
import { RequestHeader, ResponseHeader } from "./header";
import { SoftwareVersion } from "./robot_id";

export const protobufPackage = "bosdyn.api";

/** Payloads are defined relative to a frame on the robot. These are the possible frames. */
export enum MountFrameName {
  /** MOUNT_FRAME_UNKNOWN - This is the default. For backwards compatibility, we assume unknown means body mount frame. */
  MOUNT_FRAME_UNKNOWN = 0,
  /** MOUNT_FRAME_BODY_PAYLOAD - The body payload mount frame, as defined in documentation. */
  MOUNT_FRAME_BODY_PAYLOAD = 1,
  /** MOUNT_FRAME_GRIPPER_PAYLOAD - The gripper payload mount frame, as defined in documentation. */
  MOUNT_FRAME_GRIPPER_PAYLOAD = 2,
  /** MOUNT_FRAME_WR1 - The wrist link frame, as defined in the gripper CAD and documentation. */
  MOUNT_FRAME_WR1 = 3,
  UNRECOGNIZED = -1,
}

export function mountFrameNameFromJSON(object: any): MountFrameName {
  switch (object) {
    case 0:
    case "MOUNT_FRAME_UNKNOWN":
      return MountFrameName.MOUNT_FRAME_UNKNOWN;
    case 1:
    case "MOUNT_FRAME_BODY_PAYLOAD":
      return MountFrameName.MOUNT_FRAME_BODY_PAYLOAD;
    case 2:
    case "MOUNT_FRAME_GRIPPER_PAYLOAD":
      return MountFrameName.MOUNT_FRAME_GRIPPER_PAYLOAD;
    case 3:
    case "MOUNT_FRAME_WR1":
      return MountFrameName.MOUNT_FRAME_WR1;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MountFrameName.UNRECOGNIZED;
  }
}

export function mountFrameNameToJSON(object: MountFrameName): string {
  switch (object) {
    case MountFrameName.MOUNT_FRAME_UNKNOWN:
      return "MOUNT_FRAME_UNKNOWN";
    case MountFrameName.MOUNT_FRAME_BODY_PAYLOAD:
      return "MOUNT_FRAME_BODY_PAYLOAD";
    case MountFrameName.MOUNT_FRAME_GRIPPER_PAYLOAD:
      return "MOUNT_FRAME_GRIPPER_PAYLOAD";
    case MountFrameName.MOUNT_FRAME_WR1:
      return "MOUNT_FRAME_WR1";
    case MountFrameName.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A Payload describes a single payload installed on the Spot platform.
 * It includes all external information necessary to represent
 * the payload to the user as a single record.
 */
export interface Payload {
  /** A unique id provided by the payload or auto-generated by the website. */
  GUID: string;
  /**
   * A human readable name describing this payload. It is provided by the
   * payload as part of the payload announcement system.
   */
  name: string;
  /**
   * A human-readable description string providing more context as to the
   * function of this payload. It is displayed in UIs.
   */
  description: string;
  /** A unique traceable per-payload serial number. */
  serialNumber: string;
  /** A list of labels used to indicate what type of payload this is. */
  labelPrefix: string[];
  /**
   * Set true once the payload is authorized by the administrator in the payload webpage.
   * Must be set to false at registration time.
   */
  isAuthorized: boolean;
  /**
   * Set true if the payload is attached to the robot.
   * Must be set to false at registration time.
   */
  isEnabled: boolean;
  /**
   * Set true for payloads registered without their own computers. These records
   * are all manually entered.
   */
  isNoncomputePayload: boolean;
  /** Payload version details. */
  version:
    | SoftwareVersion
    | undefined;
  /** The pose of the payload relative to the body frame. */
  bodyTformPayload:
    | SE3Pose
    | undefined;
  /** The pose of the payload relative to the mount frame. */
  mountTformPayload:
    | SE3Pose
    | undefined;
  /**
   * Optional - mount frame_name (if not included, payload is assumed to be in the body mount
   * frame)
   */
  mountFrameName: MountFrameName;
  /**
   * Number of seconds to wait between heartbeats before assuming payload is no longer live
   * If unset (0) liveness checks will be disabled for this service.
   */
  livenessTimeoutSecs: number;
  /**
   * IP address of the payload for the robot to ping
   * If left empty, assume that the payload will send heartbeats
   */
  ipv4Address: string;
  /** In mbps (10, 100, 1000, etc) */
  linkSpeed: number;
  /** The mass and volume properties of the payload. */
  massVolumeProperties:
    | PayloadMassVolumeProperties
    | undefined;
  /** A list of possible physical configurations for the payload. */
  presetConfigurations: PayloadPreset[];
}

/** The physical configurations for the payload. */
export interface PayloadPreset {
  /**
   * A human readable name describing this configuration. It is displayed in
   * the admin console, but will not overwrite the top level payload name.
   */
  presetName: string;
  /**
   * A human-readable description providing context on this configuration. It is
   * displayed in the admin console.
   */
  description: string;
  /** The pose of the payload relative to the body frame. */
  mountTformPayload:
    | SE3Pose
    | undefined;
  /**
   * Optional - mount frame_name (if not included, payload is assumed to be in the body mount
   * frame)
   */
  mountFrameName: MountFrameName;
  /** The mass and volume properties of the payload. */
  massVolumeProperties:
    | PayloadMassVolumeProperties
    | undefined;
  /** A list of labels used to indicate what type of payload this is. */
  labelPrefix: string[];
}

/**
 * PayloadMassVolumeProperties contain mass and volume information for the payload
 * in the format that the user interacts with it. It is transmitted to the control
 * and perception systems and processed there to inform those systems.
 */
export interface PayloadMassVolumeProperties {
  /** Total mass of payload in kg. */
  totalMass: number;
  /** Position of the center of mass of the payload in the payload frame. Meters. */
  comPosRtPayload:
    | Vec3
    | undefined;
  /**
   * The moment of inertia of the payload, represented about the payload
   * center of mass, in the payload frame. Units in [kg*m^2].
   */
  moiTensor:
    | MomentOfIntertia
    | undefined;
  /**
   * Zero or more bounding boxes indicating the occupied volume of the payload.
   * These boxes must be represented in the payload frame by specifying
   * Must have Box3WithFrame.frame_name == "payload".
   */
  boundingBox: Box3WithFrame[];
  /**
   * Joint limits defining limits to range of motion of the hips of the robot,
   * in order to prevent collisions with the payload.
   * This field is optional and is only recommended for advanced development
   * purposes.
   */
  jointLimits: JointLimits[];
}

/**
 * Structure describing the moment of inertia of a body. The xx, yy, zz fields
 * are the diagonal of the MOI tensor, and the xy, xz, and yz fields are the
 * off diagonal terms.
 */
export interface MomentOfIntertia {
  xx: number;
  yy: number;
  zz: number;
  xy: number;
  xz: number;
  yz: number;
}

/** JointLimits contain hip joint angles where limb to payload collisions occur. */
export interface JointLimits {
  /** Label identifying the respective limb to which these apply [fr,fl,hr,hl] */
  label: string;
  /**
   * (hy, hx) coordinates outlining the hip joint limits where collisions occur
   * between robot hip and payload. Paired vectors must be of equal length.
   * Angles are measured with actual contact. Appropriate margin will be provided
   * in software. Radians.
   * Left legs must have hx > 0. Right legs must have hx < 0.
   */
  hy: number[];
  /** All legs must have hy > 1.3. */
  hx: number[];
}

/** The ListPayloads request message sent to the robot to get all known payloads. */
export interface ListPayloadsRequest {
  /** Common request header. */
  header: RequestHeader | undefined;
}

/** The ListPayloads response message returns all payloads registered in the robot's directory. */
export interface ListPayloadsResponse {
  /** Common response header. */
  header:
    | ResponseHeader
    | undefined;
  /** The returned list of payloads registered in the directory. */
  payloads: Payload[];
}

function createBasePayload(): Payload {
  return {
    GUID: "",
    name: "",
    description: "",
    serialNumber: "",
    labelPrefix: [],
    isAuthorized: false,
    isEnabled: false,
    isNoncomputePayload: false,
    version: undefined,
    bodyTformPayload: undefined,
    mountTformPayload: undefined,
    mountFrameName: 0,
    livenessTimeoutSecs: 0,
    ipv4Address: "",
    linkSpeed: 0,
    massVolumeProperties: undefined,
    presetConfigurations: [],
  };
}

export const Payload: MessageFns<Payload> = {
  encode(message: Payload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.GUID !== "") {
      writer.uint32(10).string(message.GUID);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.serialNumber !== "") {
      writer.uint32(146).string(message.serialNumber);
    }
    for (const v of message.labelPrefix) {
      writer.uint32(74).string(v!);
    }
    if (message.isAuthorized !== false) {
      writer.uint32(32).bool(message.isAuthorized);
    }
    if (message.isEnabled !== false) {
      writer.uint32(40).bool(message.isEnabled);
    }
    if (message.isNoncomputePayload !== false) {
      writer.uint32(48).bool(message.isNoncomputePayload);
    }
    if (message.version !== undefined) {
      SoftwareVersion.encode(message.version, writer.uint32(98).fork()).join();
    }
    if (message.bodyTformPayload !== undefined) {
      SE3Pose.encode(message.bodyTformPayload, writer.uint32(58).fork()).join();
    }
    if (message.mountTformPayload !== undefined) {
      SE3Pose.encode(message.mountTformPayload, writer.uint32(66).fork()).join();
    }
    if (message.mountFrameName !== 0) {
      writer.uint32(104).int32(message.mountFrameName);
    }
    if (message.livenessTimeoutSecs !== 0) {
      writer.uint32(121).double(message.livenessTimeoutSecs);
    }
    if (message.ipv4Address !== "") {
      writer.uint32(130).string(message.ipv4Address);
    }
    if (message.linkSpeed !== 0) {
      writer.uint32(136).int32(message.linkSpeed);
    }
    if (message.massVolumeProperties !== undefined) {
      PayloadMassVolumeProperties.encode(message.massVolumeProperties, writer.uint32(82).fork()).join();
    }
    for (const v of message.presetConfigurations) {
      PayloadPreset.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Payload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.GUID = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.labelPrefix.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isAuthorized = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isNoncomputePayload = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.version = SoftwareVersion.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.bodyTformPayload = SE3Pose.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.mountTformPayload = SE3Pose.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.mountFrameName = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.livenessTimeoutSecs = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ipv4Address = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.linkSpeed = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.massVolumeProperties = PayloadMassVolumeProperties.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.presetConfigurations.push(PayloadPreset.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Payload {
    return {
      GUID: isSet(object.GUID) ? globalThis.String(object.GUID) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      labelPrefix: globalThis.Array.isArray(object?.labelPrefix)
        ? object.labelPrefix.map((e: any) => globalThis.String(e))
        : [],
      isAuthorized: isSet(object.isAuthorized) ? globalThis.Boolean(object.isAuthorized) : false,
      isEnabled: isSet(object.isEnabled) ? globalThis.Boolean(object.isEnabled) : false,
      isNoncomputePayload: isSet(object.isNoncomputePayload) ? globalThis.Boolean(object.isNoncomputePayload) : false,
      version: isSet(object.version) ? SoftwareVersion.fromJSON(object.version) : undefined,
      bodyTformPayload: isSet(object.bodyTformPayload) ? SE3Pose.fromJSON(object.bodyTformPayload) : undefined,
      mountTformPayload: isSet(object.mountTformPayload) ? SE3Pose.fromJSON(object.mountTformPayload) : undefined,
      mountFrameName: isSet(object.mountFrameName) ? mountFrameNameFromJSON(object.mountFrameName) : 0,
      livenessTimeoutSecs: isSet(object.livenessTimeoutSecs) ? globalThis.Number(object.livenessTimeoutSecs) : 0,
      ipv4Address: isSet(object.ipv4Address) ? globalThis.String(object.ipv4Address) : "",
      linkSpeed: isSet(object.linkSpeed) ? globalThis.Number(object.linkSpeed) : 0,
      massVolumeProperties: isSet(object.massVolumeProperties)
        ? PayloadMassVolumeProperties.fromJSON(object.massVolumeProperties)
        : undefined,
      presetConfigurations: globalThis.Array.isArray(object?.presetConfigurations)
        ? object.presetConfigurations.map((e: any) => PayloadPreset.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Payload): unknown {
    const obj: any = {};
    if (message.GUID !== "") {
      obj.GUID = message.GUID;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.labelPrefix?.length) {
      obj.labelPrefix = message.labelPrefix;
    }
    if (message.isAuthorized !== false) {
      obj.isAuthorized = message.isAuthorized;
    }
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.isNoncomputePayload !== false) {
      obj.isNoncomputePayload = message.isNoncomputePayload;
    }
    if (message.version !== undefined) {
      obj.version = SoftwareVersion.toJSON(message.version);
    }
    if (message.bodyTformPayload !== undefined) {
      obj.bodyTformPayload = SE3Pose.toJSON(message.bodyTformPayload);
    }
    if (message.mountTformPayload !== undefined) {
      obj.mountTformPayload = SE3Pose.toJSON(message.mountTformPayload);
    }
    if (message.mountFrameName !== 0) {
      obj.mountFrameName = mountFrameNameToJSON(message.mountFrameName);
    }
    if (message.livenessTimeoutSecs !== 0) {
      obj.livenessTimeoutSecs = message.livenessTimeoutSecs;
    }
    if (message.ipv4Address !== "") {
      obj.ipv4Address = message.ipv4Address;
    }
    if (message.linkSpeed !== 0) {
      obj.linkSpeed = Math.round(message.linkSpeed);
    }
    if (message.massVolumeProperties !== undefined) {
      obj.massVolumeProperties = PayloadMassVolumeProperties.toJSON(message.massVolumeProperties);
    }
    if (message.presetConfigurations?.length) {
      obj.presetConfigurations = message.presetConfigurations.map((e) => PayloadPreset.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Payload>, I>>(base?: I): Payload {
    return Payload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Payload>, I>>(object: I): Payload {
    const message = createBasePayload();
    message.GUID = object.GUID ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.labelPrefix = object.labelPrefix?.map((e) => e) || [];
    message.isAuthorized = object.isAuthorized ?? false;
    message.isEnabled = object.isEnabled ?? false;
    message.isNoncomputePayload = object.isNoncomputePayload ?? false;
    message.version = (object.version !== undefined && object.version !== null)
      ? SoftwareVersion.fromPartial(object.version)
      : undefined;
    message.bodyTformPayload = (object.bodyTformPayload !== undefined && object.bodyTformPayload !== null)
      ? SE3Pose.fromPartial(object.bodyTformPayload)
      : undefined;
    message.mountTformPayload = (object.mountTformPayload !== undefined && object.mountTformPayload !== null)
      ? SE3Pose.fromPartial(object.mountTformPayload)
      : undefined;
    message.mountFrameName = object.mountFrameName ?? 0;
    message.livenessTimeoutSecs = object.livenessTimeoutSecs ?? 0;
    message.ipv4Address = object.ipv4Address ?? "";
    message.linkSpeed = object.linkSpeed ?? 0;
    message.massVolumeProperties = (object.massVolumeProperties !== undefined && object.massVolumeProperties !== null)
      ? PayloadMassVolumeProperties.fromPartial(object.massVolumeProperties)
      : undefined;
    message.presetConfigurations = object.presetConfigurations?.map((e) => PayloadPreset.fromPartial(e)) || [];
    return message;
  },
};

function createBasePayloadPreset(): PayloadPreset {
  return {
    presetName: "",
    description: "",
    mountTformPayload: undefined,
    mountFrameName: 0,
    massVolumeProperties: undefined,
    labelPrefix: [],
  };
}

export const PayloadPreset: MessageFns<PayloadPreset> = {
  encode(message: PayloadPreset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetName !== "") {
      writer.uint32(10).string(message.presetName);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.mountTformPayload !== undefined) {
      SE3Pose.encode(message.mountTformPayload, writer.uint32(26).fork()).join();
    }
    if (message.mountFrameName !== 0) {
      writer.uint32(48).int32(message.mountFrameName);
    }
    if (message.massVolumeProperties !== undefined) {
      PayloadMassVolumeProperties.encode(message.massVolumeProperties, writer.uint32(34).fork()).join();
    }
    for (const v of message.labelPrefix) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PayloadPreset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePayloadPreset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.presetName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mountTformPayload = SE3Pose.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.mountFrameName = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.massVolumeProperties = PayloadMassVolumeProperties.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.labelPrefix.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PayloadPreset {
    return {
      presetName: isSet(object.presetName) ? globalThis.String(object.presetName) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      mountTformPayload: isSet(object.mountTformPayload) ? SE3Pose.fromJSON(object.mountTformPayload) : undefined,
      mountFrameName: isSet(object.mountFrameName) ? mountFrameNameFromJSON(object.mountFrameName) : 0,
      massVolumeProperties: isSet(object.massVolumeProperties)
        ? PayloadMassVolumeProperties.fromJSON(object.massVolumeProperties)
        : undefined,
      labelPrefix: globalThis.Array.isArray(object?.labelPrefix)
        ? object.labelPrefix.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PayloadPreset): unknown {
    const obj: any = {};
    if (message.presetName !== "") {
      obj.presetName = message.presetName;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.mountTformPayload !== undefined) {
      obj.mountTformPayload = SE3Pose.toJSON(message.mountTformPayload);
    }
    if (message.mountFrameName !== 0) {
      obj.mountFrameName = mountFrameNameToJSON(message.mountFrameName);
    }
    if (message.massVolumeProperties !== undefined) {
      obj.massVolumeProperties = PayloadMassVolumeProperties.toJSON(message.massVolumeProperties);
    }
    if (message.labelPrefix?.length) {
      obj.labelPrefix = message.labelPrefix;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PayloadPreset>, I>>(base?: I): PayloadPreset {
    return PayloadPreset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PayloadPreset>, I>>(object: I): PayloadPreset {
    const message = createBasePayloadPreset();
    message.presetName = object.presetName ?? "";
    message.description = object.description ?? "";
    message.mountTformPayload = (object.mountTformPayload !== undefined && object.mountTformPayload !== null)
      ? SE3Pose.fromPartial(object.mountTformPayload)
      : undefined;
    message.mountFrameName = object.mountFrameName ?? 0;
    message.massVolumeProperties = (object.massVolumeProperties !== undefined && object.massVolumeProperties !== null)
      ? PayloadMassVolumeProperties.fromPartial(object.massVolumeProperties)
      : undefined;
    message.labelPrefix = object.labelPrefix?.map((e) => e) || [];
    return message;
  },
};

function createBasePayloadMassVolumeProperties(): PayloadMassVolumeProperties {
  return { totalMass: 0, comPosRtPayload: undefined, moiTensor: undefined, boundingBox: [], jointLimits: [] };
}

export const PayloadMassVolumeProperties: MessageFns<PayloadMassVolumeProperties> = {
  encode(message: PayloadMassVolumeProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalMass !== 0) {
      writer.uint32(21).float(message.totalMass);
    }
    if (message.comPosRtPayload !== undefined) {
      Vec3.encode(message.comPosRtPayload, writer.uint32(26).fork()).join();
    }
    if (message.moiTensor !== undefined) {
      MomentOfIntertia.encode(message.moiTensor, writer.uint32(34).fork()).join();
    }
    for (const v of message.boundingBox) {
      Box3WithFrame.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.jointLimits) {
      JointLimits.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PayloadMassVolumeProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePayloadMassVolumeProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.totalMass = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comPosRtPayload = Vec3.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.moiTensor = MomentOfIntertia.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.boundingBox.push(Box3WithFrame.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.jointLimits.push(JointLimits.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PayloadMassVolumeProperties {
    return {
      totalMass: isSet(object.totalMass) ? globalThis.Number(object.totalMass) : 0,
      comPosRtPayload: isSet(object.comPosRtPayload) ? Vec3.fromJSON(object.comPosRtPayload) : undefined,
      moiTensor: isSet(object.moiTensor) ? MomentOfIntertia.fromJSON(object.moiTensor) : undefined,
      boundingBox: globalThis.Array.isArray(object?.boundingBox)
        ? object.boundingBox.map((e: any) => Box3WithFrame.fromJSON(e))
        : [],
      jointLimits: globalThis.Array.isArray(object?.jointLimits)
        ? object.jointLimits.map((e: any) => JointLimits.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PayloadMassVolumeProperties): unknown {
    const obj: any = {};
    if (message.totalMass !== 0) {
      obj.totalMass = message.totalMass;
    }
    if (message.comPosRtPayload !== undefined) {
      obj.comPosRtPayload = Vec3.toJSON(message.comPosRtPayload);
    }
    if (message.moiTensor !== undefined) {
      obj.moiTensor = MomentOfIntertia.toJSON(message.moiTensor);
    }
    if (message.boundingBox?.length) {
      obj.boundingBox = message.boundingBox.map((e) => Box3WithFrame.toJSON(e));
    }
    if (message.jointLimits?.length) {
      obj.jointLimits = message.jointLimits.map((e) => JointLimits.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PayloadMassVolumeProperties>, I>>(base?: I): PayloadMassVolumeProperties {
    return PayloadMassVolumeProperties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PayloadMassVolumeProperties>, I>>(object: I): PayloadMassVolumeProperties {
    const message = createBasePayloadMassVolumeProperties();
    message.totalMass = object.totalMass ?? 0;
    message.comPosRtPayload = (object.comPosRtPayload !== undefined && object.comPosRtPayload !== null)
      ? Vec3.fromPartial(object.comPosRtPayload)
      : undefined;
    message.moiTensor = (object.moiTensor !== undefined && object.moiTensor !== null)
      ? MomentOfIntertia.fromPartial(object.moiTensor)
      : undefined;
    message.boundingBox = object.boundingBox?.map((e) => Box3WithFrame.fromPartial(e)) || [];
    message.jointLimits = object.jointLimits?.map((e) => JointLimits.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMomentOfIntertia(): MomentOfIntertia {
  return { xx: 0, yy: 0, zz: 0, xy: 0, xz: 0, yz: 0 };
}

export const MomentOfIntertia: MessageFns<MomentOfIntertia> = {
  encode(message: MomentOfIntertia, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.xx !== 0) {
      writer.uint32(21).float(message.xx);
    }
    if (message.yy !== 0) {
      writer.uint32(29).float(message.yy);
    }
    if (message.zz !== 0) {
      writer.uint32(37).float(message.zz);
    }
    if (message.xy !== 0) {
      writer.uint32(45).float(message.xy);
    }
    if (message.xz !== 0) {
      writer.uint32(53).float(message.xz);
    }
    if (message.yz !== 0) {
      writer.uint32(61).float(message.yz);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MomentOfIntertia {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMomentOfIntertia();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.xx = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.yy = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.zz = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.xy = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.xz = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yz = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MomentOfIntertia {
    return {
      xx: isSet(object.xx) ? globalThis.Number(object.xx) : 0,
      yy: isSet(object.yy) ? globalThis.Number(object.yy) : 0,
      zz: isSet(object.zz) ? globalThis.Number(object.zz) : 0,
      xy: isSet(object.xy) ? globalThis.Number(object.xy) : 0,
      xz: isSet(object.xz) ? globalThis.Number(object.xz) : 0,
      yz: isSet(object.yz) ? globalThis.Number(object.yz) : 0,
    };
  },

  toJSON(message: MomentOfIntertia): unknown {
    const obj: any = {};
    if (message.xx !== 0) {
      obj.xx = message.xx;
    }
    if (message.yy !== 0) {
      obj.yy = message.yy;
    }
    if (message.zz !== 0) {
      obj.zz = message.zz;
    }
    if (message.xy !== 0) {
      obj.xy = message.xy;
    }
    if (message.xz !== 0) {
      obj.xz = message.xz;
    }
    if (message.yz !== 0) {
      obj.yz = message.yz;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MomentOfIntertia>, I>>(base?: I): MomentOfIntertia {
    return MomentOfIntertia.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MomentOfIntertia>, I>>(object: I): MomentOfIntertia {
    const message = createBaseMomentOfIntertia();
    message.xx = object.xx ?? 0;
    message.yy = object.yy ?? 0;
    message.zz = object.zz ?? 0;
    message.xy = object.xy ?? 0;
    message.xz = object.xz ?? 0;
    message.yz = object.yz ?? 0;
    return message;
  },
};

function createBaseJointLimits(): JointLimits {
  return { label: "", hy: [], hx: [] };
}

export const JointLimits: MessageFns<JointLimits> = {
  encode(message: JointLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    writer.uint32(26).fork();
    for (const v of message.hy) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.hx) {
      writer.float(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 3: {
          if (tag === 29) {
            message.hy.push(reader.float());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.hy.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 37) {
            message.hx.push(reader.float());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.hx.push(reader.float());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointLimits {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      hy: globalThis.Array.isArray(object?.hy) ? object.hy.map((e: any) => globalThis.Number(e)) : [],
      hx: globalThis.Array.isArray(object?.hx) ? object.hx.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: JointLimits): unknown {
    const obj: any = {};
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.hy?.length) {
      obj.hy = message.hy;
    }
    if (message.hx?.length) {
      obj.hx = message.hx;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointLimits>, I>>(base?: I): JointLimits {
    return JointLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointLimits>, I>>(object: I): JointLimits {
    const message = createBaseJointLimits();
    message.label = object.label ?? "";
    message.hy = object.hy?.map((e) => e) || [];
    message.hx = object.hx?.map((e) => e) || [];
    return message;
  },
};

function createBaseListPayloadsRequest(): ListPayloadsRequest {
  return { header: undefined };
}

export const ListPayloadsRequest: MessageFns<ListPayloadsRequest> = {
  encode(message: ListPayloadsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      RequestHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPayloadsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPayloadsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = RequestHeader.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPayloadsRequest {
    return { header: isSet(object.header) ? RequestHeader.fromJSON(object.header) : undefined };
  },

  toJSON(message: ListPayloadsRequest): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = RequestHeader.toJSON(message.header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPayloadsRequest>, I>>(base?: I): ListPayloadsRequest {
    return ListPayloadsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPayloadsRequest>, I>>(object: I): ListPayloadsRequest {
    const message = createBaseListPayloadsRequest();
    message.header = (object.header !== undefined && object.header !== null)
      ? RequestHeader.fromPartial(object.header)
      : undefined;
    return message;
  },
};

function createBaseListPayloadsResponse(): ListPayloadsResponse {
  return { header: undefined, payloads: [] };
}

export const ListPayloadsResponse: MessageFns<ListPayloadsResponse> = {
  encode(message: ListPayloadsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      ResponseHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.payloads) {
      Payload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPayloadsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPayloadsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = ResponseHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payloads.push(Payload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPayloadsResponse {
    return {
      header: isSet(object.header) ? ResponseHeader.fromJSON(object.header) : undefined,
      payloads: globalThis.Array.isArray(object?.payloads) ? object.payloads.map((e: any) => Payload.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListPayloadsResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = ResponseHeader.toJSON(message.header);
    }
    if (message.payloads?.length) {
      obj.payloads = message.payloads.map((e) => Payload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPayloadsResponse>, I>>(base?: I): ListPayloadsResponse {
    return ListPayloadsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPayloadsResponse>, I>>(object: I): ListPayloadsResponse {
    const message = createBaseListPayloadsResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? ResponseHeader.fromPartial(object.header)
      : undefined;
    message.payloads = object.payloads?.map((e) => Payload.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
